



















import { Component, Vue } from 'vue-property-decorator';
import { mapActions } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';
import { ActionTypes } from '@/store/disbursement';
// import BalanceJumbotron from '../components/BalanceJumbotron.vue';
import api from '@/libs/api';
import { DisbursementMerchantBalanceResponse } from '@/libs/api.interfaces';
import BussinessBalanceBox from './components/BusinessBalanceBox.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Tab,
    BussinessBalanceBox,
  },
  // methods: mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_BALANCE }),
})
export default class BussinessDetail extends Vue {
  loading = true;
  name = 'Balance';
  balance = 0;
  merchantCode = '';
  tabs = [{
    label: 'Pricing',
    to: 'pricing',
  },
  {
    label: 'Multi-Layer Approval',
    to: 'setting',
  },
  {
    label: 'Configuration',
    to: 'configuration',
  },
  {
    label: 'Topup',
    to: 'topup',
  },
  ];

  // getBalance!: () => void;

  // mounted() {
  //   this.getBalance();
  // }

  async created() {
    // console.log(this.$route.params.id);
    await this.getBalance();
    // this.getPricing(false);
    // this.getBankList();
    // this.clearData();
  }

  async getBalance() {
    this.loading = true;
    try {
      const { data } = await api.get('/prepaid/merchant/balance', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_id: this.$route.params.id,
        },
      });

      const merchant = data.data[0];
      this.name = merchant.name;
      // this.balance = merchant.histories ? Number(merchant.histories.balance) : 0;
      this.balance = data.totalBalance;
      this.merchantCode = merchant.merchant_code;
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }
}
